"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _registerService = _interopRequireDefault(require("crm_data/flux/registerService"));

var _dispatch = require("crm_data/flux/dispatch");

var _TimelineAPI = _interopRequireDefault(require("crm_data/timeline/TimelineAPI"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _CRMToContactsObjectTypes = _interopRequireDefault(require("crm_data/constants/CRMToContactsObjectTypes"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _Raven = _interopRequireDefault(require("Raven"));

var _EngagementsSearchAPIQuery = _interopRequireDefault(require("crm_data/engagements/api/EngagementsSearchAPIQuery"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _EngagementsStore = _interopRequireDefault(require("crm_data/engagements/EngagementsStore"));

var _fillExtraEventOptions = require("crm_ui/timeline/helpers/fillExtraEventOptions");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _spread = _interopRequireDefault(require("q/js/lib/spread"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _EngagementTypes = _interopRequireDefault(require("customer-data-objects/engagement/EngagementTypes"));

var _handlers;

var EMAIL = _EngagementTypes.default.EMAIL,
    TASK = _EngagementTypes.default.TASK,
    MEETING = _EngagementTypes.default.MEETING,
    CALL = _EngagementTypes.default.CALL,
    NOTE = _EngagementTypes.default.NOTE,
    INCOMING_EMAIL = _EngagementTypes.default.INCOMING_EMAIL,
    CONVERSATION_SESSION = _EngagementTypes.default.CONVERSATION_SESSION;
var engagementFilterToESFilter = (0, _immutable.Map)({
  ENGAGEMENTS_CALLS: CALL,
  ENGAGEMENTS_EMAILS_TRIMMED: EMAIL,
  ENGAGEMENTS_MEETINGS: MEETING,
  ENGAGEMENTS_NOTES: NOTE,
  ENGAGEMENTS_TASKS: TASK,
  ENGAGEMENTS_CONVERSATION_SESSIONS: CONVERSATION_SESSION
});

function hoistEngagements(data) {
  var engagementIds = data.get('events').filter(function (event) {
    return event.hasIn(['eventData', 'engagement', 'id']);
  }).map(function (event) {
    return event.getIn(['eventData', 'engagement', 'id']);
  });

  _EngagementsStore.default.get(engagementIds);
}

function shouldUseElasticSearch(requestPayload) {
  return requestPayload.get('selectedUsers') && requestPayload.get('selectedUsers').size || requestPayload.get('selectedTeams') && requestPayload.get('selectedTeams').size || requestPayload.get('searchText') && requestPayload.get('searchText').length;
}

function logCountToNewRelic(failureType, items) {
  if (window.newrelic && Math.random() < 0.25) {
    items.forEach(function (item) {
      window.newrelic.addPageAction("timeline" + failureType, {
        item: item
      });
    });
  }
}

function fetchWithErrorHandling(requestPayload, successCallback) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$timesToRetry = _ref.timesToRetry,
      timesToRetry = _ref$timesToRetry === void 0 ? 3 : _ref$timesToRetry,
      _ref$useDefaults = _ref.useDefaults,
      useDefaults = _ref$useDefaults === void 0 ? false : _ref$useDefaults,
      _ref$isFirstFetch = _ref.isFirstFetch,
      isFirstFetch = _ref$isFirstFetch === void 0 ? false : _ref$isFirstFetch;

  var promises = [useDefaults ? _TimelineAPI.default.fetchDefaults(requestPayload) : _TimelineAPI.default.fetch(requestPayload)];

  if (isFirstFetch) {
    promises = [].concat((0, _toConsumableArray2.default)(promises), [_TimelineAPI.default.fetchIntegrationEvents(), _TimelineAPI.default.fetchInstalledHubSpotOwnedIntegrations()]);
  }

  return (0, _spread.default)(promises, function (data, integrationsAppsData, installedIntegrationsData) {
    if (!data) {
      _devLogger.default.warn({
        message: 'Timeline failed with no data'
      });

      return data;
    } // somehow, occasionally we are getting a mutable data value


    if (!_immutable.Map.isMap(data)) {
      _Raven.default.captureMessage('Timeline data not immutable', {
        extra: {
          requestPayload: requestPayload,
          data: data
        }
      });

      return data;
    }

    if (integrationsAppsData || installedIntegrationsData) {
      data = data.merge({
        integrationsAppsData: integrationsAppsData,
        installedIntegrationsData: installedIntegrationsData
      });
    }

    var dataFailed = data.get('failed');
    var dataTimedOut = data.get('timedOut');
    var hasDataTimedOut = dataTimedOut && !dataTimedOut.isEmpty();
    var hasDataFailed = dataFailed && !dataFailed.isEmpty();

    if (hasDataFailed) {
      _devLogger.default.warn({
        message: "Timeline items failed: " + dataFailed.toJS()
      });

      logCountToNewRelic('DataFailed', dataFailed);
    }

    if (hasDataTimedOut) {
      _devLogger.default.warn({
        message: "Timeline items timed out: " + dataTimedOut.toJS()
      });

      logCountToNewRelic('DataTimedOut', dataTimedOut);
    }

    if (timesToRetry === 0) {
      return data;
    }

    if (hasDataTimedOut) {
      requestPayload = requestPayload.set('eventOptions', dataTimedOut);
      fetchWithErrorHandling(requestPayload, successCallback, {
        timesToRetry: timesToRetry - 1,
        isFirstFetch: isFirstFetch
      });
    }

    return data;
  });
}

function getNextTimestampFromElasticSearch(originalPayload, data) {
  var nextTimestamp = data.get('engagements').last() && data.get('engagements').last().getIn(['engagement', 'timestamp']);
  return nextTimestamp || originalPayload.get('fromDate');
}

function handleSuccessfulElasticSearchFetch(originalPayload, data) {
  var timelineEvents = data.get('engagements').map(function (engagement) {
    return (0, _immutable.Map)({
      etype: 'eventEngagement',
      eventData: engagement
    });
  });
  var nextTimestamp = getNextTimestampFromElasticSearch(originalPayload, data);
  var fromDate = nextTimestamp || originalPayload.get('fromDate');
  originalPayload = originalPayload.set('fromDate', fromDate);
  data = data.set('events', timelineEvents).set('hasMore', data.get('has-more')).set('originalPayload', originalPayload).set('nextTimestamp', nextTimestamp);
  (0, _dispatch.dispatch)(_ActionTypes.FETCH_TIMELINE_ITEMS_SUCCESS, data);
}

function getSuccessCallback(originalPayload) {
  return function (data) {
    if (shouldUseElasticSearch(originalPayload)) {
      handleSuccessfulElasticSearchFetch(originalPayload, data);
    } else {
      data = data.set('originalPayload', originalPayload);
      (0, _dispatch.dispatch)(_ActionTypes.FETCH_TIMELINE_ITEMS_SUCCESS, data);
      hoistEngagements(data);
    }
  };
}

function getSuccessfulPollingCallback(originalPayload) {
  return function (data) {
    data = data.set('originalPayload', originalPayload);
    (0, _dispatch.dispatch)(_ActionTypes.POLLING_FETCH_TIMELINE_ITEMS_SUCCESS, data);
  };
}

function getSuccessfulVisualForceCallback(originalPayload) {
  return function (data) {
    data = data.set('originalPayload', originalPayload);
    (0, _dispatch.dispatch)(_ActionTypes.FETCH_TIMELINE_ITEMS_FOR_VFP_SUCCESS, data);
  };
}

function getErrorCallback(actionType) {
  return function () {
    (0, _dispatch.dispatch)(actionType);
  };
}
/**
 * @deprecated This method can be removed once @cmckenna runs
 *             the backfill to update all users' UserSettings
 *             for filters. For now we need to manually send
 *             the options because we don't know if the user
 *             has updated settings or not.
 */


function getEventOptions(requestPayload) {
  var eventOptions = requestPayload.get('eventOptions');
  var objectType = requestPayload.get('objectType');

  if (!eventOptions) {
    eventOptions = (0, _immutable.List)();
  }

  return (0, _fillExtraEventOptions.fillExtraEventOptions)(objectType, eventOptions);
}

function getFormattedRequestPayload(requestPayload) {
  var subjectId = requestPayload.get('subjectId');
  var objectType = requestPayload.get('objectType');
  return requestPayload.merge({
    objectId: subjectId,
    objectType: _CRMToContactsObjectTypes.default[objectType],
    eventOptions: getEventOptions(requestPayload)
  });
}

function fetchTimelineEvents(requestPayload, successCallback, errorCallback) {
  var isFirstFetch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!requestPayload.get('eventOptions') || !requestPayload.get('eventOptions').size) {
    (0, _Dispatch.dispatchQueue)(_ActionTypes.CLEAR_ALL_FILTERS);
    return;
  }

  var formattedRequestPayload = getFormattedRequestPayload(requestPayload);
  fetchWithErrorHandling(formattedRequestPayload, successCallback, {
    isFirstFetch: isFirstFetch
  }).then(successCallback, errorCallback);
}

function performSecondRequest(nextTimestamp, originalPayload, formattedRequestPayload, useDefaults) {
  var nextDateRange = (0, _immutable.Map)({
    now: originalPayload.get('now'),
    toDate: nextTimestamp,
    fromDate: _I18n.default.moment.userTz(nextTimestamp).startOf(_TimelineConstants.UNITS_OF_TIME.get('MONTHS')).valueOf()
  });
  var nextOriginalPayload = originalPayload.merge(nextDateRange);
  var nextActivitiesFetchPayload = formattedRequestPayload.merge(nextDateRange);
  var secondSuccessCallback = getSuccessCallback(nextOriginalPayload);
  var errorCallback = getErrorCallback(_ActionTypes.FETCH_TIMELINE_ITEMS_ERROR);
  fetchWithErrorHandling(nextActivitiesFetchPayload, secondSuccessCallback, {
    useDefaults: useDefaults
  }).then(secondSuccessCallback, errorCallback);
}

function fetchAfterNoResults(state, requestPayload) {
  var useDefaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var originalPayload = requestPayload;
  var formattedRequestPayload = getFormattedRequestPayload(originalPayload);

  var firstSuccessCallback = function firstSuccessCallback(data) {
    data = data.set('originalPayload', originalPayload);
    (0, _dispatch.dispatch)(_ActionTypes.FETCH_TIMELINE_ITEMS_SUCCESS, data);
    hoistEngagements(data);
    var nextTimestamp = data.get('nextTimestamp');
    var shouldStopFetch = data.get('events').size || !nextTimestamp;

    if (!shouldStopFetch) {
      performSecondRequest(nextTimestamp, originalPayload, formattedRequestPayload, useDefaults);
    }
  };

  var errorCallback = getErrorCallback(_ActionTypes.FETCH_TIMELINE_ITEMS_ERROR);
  fetchWithErrorHandling(formattedRequestPayload, firstSuccessCallback, {
    useDefaults: useDefaults,
    isFirstFetch: useDefaults
  }).then(firstSuccessCallback, errorCallback);
}

function getFormattedRequestPayloadForES(requestPayload) {
  var subjectId = requestPayload.get('subjectId');
  var objectType = requestPayload.get('objectType');
  var engagementsToFetch = requestPayload.get('eventOptions').map(function (option) {
    return engagementFilterToESFilter.get(option);
  }).filter(_identity.default);

  if (engagementsToFetch.contains(EMAIL)) {
    engagementsToFetch = engagementsToFetch.push(INCOMING_EMAIL);
  }

  if (!engagementsToFetch.size) {
    engagementsToFetch = (0, _immutable.List)(['NOTE']);
  }

  var filters = [{
    operator: 'IN',
    property: "associations." + objectType.toLowerCase(),
    values: [subjectId]
  }, {
    operator: 'IN',
    property: 'engagement.type',
    values: engagementsToFetch.toArray()
  }];

  if (requestPayload.get('selectedTeams') && requestPayload.get('selectedTeams').size) {
    filters.push({
      operator: 'IN',
      property: 'engagement.teamId',
      values: requestPayload.get('selectedTeams')
    });
  }

  if (requestPayload.get('selectedUsers') && requestPayload.get('selectedUsers').size) {
    filters.push({
      operator: 'IN',
      property: 'engagement.createdBy',
      values: requestPayload.get('selectedUsers')
    });
  }

  if (requestPayload.get('toDate')) {
    filters.push({
      operator: 'LTE',
      property: 'engagement.timestamp',
      value: requestPayload.get('toDate')
    });
  }

  var query = _EngagementsSearchAPIQuery.default.default({
    count: 20,
    sorts: [{
      property: 'engagement.timestamp',
      order: 'DESC'
    }],
    filterGroups: [{
      filters: filters
    }]
  }, {
    excludeDefaultFilters: true
  });

  if (requestPayload.get('searchText') && requestPayload.get('searchText').length) {
    query = query.set('query', requestPayload.get('searchText'));
  }

  return query;
}

function fetchResultsByUsersAndTeams(state, requestPayload) {
  var formattedRequestPayload = getFormattedRequestPayloadForES(requestPayload);
  var successCallback = getSuccessCallback(requestPayload);
  var errorCallback = getErrorCallback(_ActionTypes.FETCH_TIMELINE_ITEMS_ERROR);

  _TimelineAPI.default.fetchTimelineByUsersAndTeams(formattedRequestPayload).then(successCallback, errorCallback);
}

var handlers = (_handlers = {}, (0, _defineProperty2.default)(_handlers, _ActionTypes.FETCHING_INITIAL_TIMELINE_EVENTS_STARTED, function (state, requestPayload) {
  if (shouldUseElasticSearch(requestPayload)) {
    fetchResultsByUsersAndTeams(state, requestPayload);
  } else {
    fetchAfterNoResults(state, requestPayload, true);
  }
}), (0, _defineProperty2.default)(_handlers, _ActionTypes.FETCH_NEXT_TIMELINE_EVENTS_STARTED, function (state, requestPayload) {
  if (shouldUseElasticSearch(requestPayload)) {
    fetchResultsByUsersAndTeams(state, requestPayload);
  } else {
    var successCallback = getSuccessCallback(requestPayload);
    var errorCallback = getErrorCallback(_ActionTypes.FETCH_TIMELINE_ITEMS_ERROR);
    fetchTimelineEvents(requestPayload, successCallback, errorCallback);
  }
}), (0, _defineProperty2.default)(_handlers, _ActionTypes.CHANGE_FILTER, function (state, _ref2) {
  var requestPayload = _ref2.requestPayload;

  if (shouldUseElasticSearch(requestPayload)) {
    fetchResultsByUsersAndTeams(state, requestPayload);
  } else {
    var successCallback = getSuccessCallback(requestPayload);
    var errorCallback = getErrorCallback(_ActionTypes.FETCH_TIMELINE_ITEMS_ERROR);
    fetchTimelineEvents(requestPayload, successCallback, errorCallback);
  }
}), (0, _defineProperty2.default)(_handlers, _ActionTypes.TIMELINE_CHANGE_USER_AND_TEAM_FILTER, function (state, _ref3) {
  var requestPayload = _ref3.requestPayload;

  if (shouldUseElasticSearch(requestPayload)) {
    fetchResultsByUsersAndTeams(state, requestPayload);
  } else {
    var successCallback = getSuccessCallback(requestPayload);
    var errorCallback = getErrorCallback(_ActionTypes.FETCH_TIMELINE_ITEMS_ERROR);
    fetchTimelineEvents(requestPayload, successCallback, errorCallback);
  }
}), (0, _defineProperty2.default)(_handlers, _ActionTypes.SET_FAVORITE_EVENT_OVERRIDE, function (state, _ref4) {
  var requestPayload = _ref4.requestPayload;

  if (shouldUseElasticSearch(requestPayload)) {
    fetchResultsByUsersAndTeams(state, requestPayload);
  } else {
    fetchAfterNoResults(state, requestPayload);
  }
}), (0, _defineProperty2.default)(_handlers, _ActionTypes.POLLING_FETCH_TIMELINE_ITEMS_STARTED, function (state, requestPayload) {
  if (shouldUseElasticSearch(requestPayload)) {
    fetchResultsByUsersAndTeams(state, requestPayload);
  } else {
    var successCallback = getSuccessfulPollingCallback(requestPayload);
    var errorCallback = getErrorCallback(_ActionTypes.POLLING_FETCH_TIMELINE_ITEMS_ERROR);
    fetchTimelineEvents(requestPayload, successCallback, errorCallback);
  }
}), (0, _defineProperty2.default)(_handlers, _ActionTypes.FETCH_TIMELINE_ITEMS_FOR_VFP_STARTED, function (state, requestPayload) {
  var successCallback = getSuccessfulVisualForceCallback(requestPayload);
  var errorCallback = getErrorCallback(_ActionTypes.FETCH_TIMELINE_ITEMS_ERROR);
  fetchTimelineEvents(requestPayload, successCallback, errorCallback, true);
}), _handlers);

var _default = (0, _registerService.default)((0, _immutable.Map)(), handlers);

exports.default = _default;
module.exports = exports.default;